import { apiClient } from '_app'
import {
  ApiResponse,
  Needs7501DocumentMichiganEmailExporterDto,
  NeedsCANOwnershipMichiganEmailExporterDto,
  MichiganSOSBundleDto,
  ToDoListsCountsDto,
  VehicleDto,
  VehicleRecallDto,
  OutboundTripDto
} from 'dtos'
import { ClusterShipperDto } from 'dtos/clusterShipperDto'
import { NeedsClusterReinstalledClusterWithOdometerPhotoDto } from 'dtos/needsClusterReinstalledClusterWithOdometerPhotoDto'
import { NeedsClusterReinstalledComboPhotoDto } from 'dtos/needsClusterReinstalledComboPhotoDto'
import { NeedsClusterReinstalledImporterDoorLabelPhotoDto } from 'dtos/needsClusterReinstalledImporterDoorLabelPhotoDto'
import { PulledClusterPhotoDto } from 'dtos/pulledClusterPhotoDto'
import { ThirdPartyClusterDeliveryPhotoDto } from 'dtos/thirdPartyClusterDeliveryPhotoDto'
import {
  ToDoListArchivedParameters,
  ToDoListCancelledParameters as ToDoListCanceledParameters,
  ToDoListNeedsBWIApprovalParameters,
  ToDoListNeedsCaRoUploadedParameters,
  ToDoListNeedsCheckInParameters,
  ToDoListNeedsClusterConversionInHouseParameters,
  ToDoListNeedsClusterConversionShipperParameters,
  ToDoListNeedsClusterDeliveredToThirdPartyConversionCompanyParameters,
  ToDoListNeedsClusterReinstalledParameters,
  ToDoListNeedsClusterRemovedParameters,
  ToDoListCreated5DaysAgoOrMoreAndHasNotBeenSentToDOTParameters,
  ToDoListNeedsIncorrectMileageResolutionParameters,
  ToDoListNeedsInfoForApplicationPacketParameters,
  ToDoListNeedsInHouseAdditionalProgrammingParameters,
  ToDoListNeedsManufacturerLabelExporterParameters,
  ToDoListNeedsManufacturerLabelParameters,
  ToDoListNeedsOEMSiteCheckedForRecallsParameters,
  ToDoListNeedsPhotoParameters,
  ToDoListNeedsRecallWorkParameters,
  ToDoListNeedsSpecialBondParameters,
  ToDoListNeedsThirdPartyAdditionalProgrammingParameters,
  ToDoListNeedsTirePressureLabelParameters,
  ToDoListNeedsTMPSLabelExporterParameters,
  ToDoListNeedsToBeAddedToPAPSParameters,
  ToDoListNeedsToBePrintedAndSignedParameters,
  ToDoListWaitingOnThirdPartyAdditionalProgrammingParameters,
  ToDoListWaitingOnThirdPartyClusterConversionParameters,
  OutboundTripsParameters
} from 'parameters'
import { base64ToArrayBuffer, URIQuery } from 'utils'
import { WaitingOnExporterToDoListParameters } from 'parameters'
import {
  ToDoListNeeds7501DocumentMichiganParameters,
  ToDoListNeedsCANOwnershipMichiganParameters,
  ToDoListNeedsDamageRepairedParameters,
  ToDoListNeedsMichiganTitleFromSecretaryOfStateParameters,
  ToDoListNeedsNewTitlesOCRdParameters,
  ToDoListNeedsToBeAddedToABundleParameters,
  ToDoListNeedsToBeTakenToFedExParameters,
  ToDoListNeedsToBeTakenToSecretaryOfStateParameters,
  ToDoListNeedsToHaveBoxFinishedParameters,
  ToDoListWaitingOnOhioTitleProcessingParameters,
  VehicleToDoListParameters
} from 'parameters/vehiclesParameters'
import { CancelToken } from 'axios'

export const getToDoListsCounts = (importBranchGuid?: string, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<ToDoListsCountsDto>>('/api/to-do-lists/counts' + URIQuery({ importBranchGuid }), { cancelToken }).then(response => response?.data)

export const getWaitingOnExporterToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/waiting-on-exporter' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsSpecialBondToDoList = (parameters: ToDoListNeedsSpecialBondParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-special-bond' + URIQuery(parameters)).then(response => response.data)

export const getNeedsManufacturerLabelImageExporter = (parameters: ToDoListNeedsManufacturerLabelExporterParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-manufacturer-label-image-exporter' + URIQuery(parameters)).then(response => response.data)

export const getNeedsTPMSTelltaleImageExporterPerAppendixBToDoList = (parameters: ToDoListNeedsTMPSLabelExporterParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-tpms-telltale-image-exporter-per-appendix-b' + URIQuery(parameters))
    .then(response => response.data)

export const getNeedsBWIApprovalToDoList = (parameters: ToDoListNeedsBWIApprovalParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-bwi-approval' + URIQuery(parameters)).then(response => response.data)

export const getNeedsToBeAddedToAPAPSToDoList = (parameters: ToDoListNeedsToBeAddedToPAPSParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-to-be-added-to-a-paps' + URIQuery(parameters)).then(response => response.data)

export const getCanceledToDoList = (parameters: ToDoListCanceledParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/cancelled' + URIQuery(parameters)).then(response => response.data)

export const getNeedsBrokerDocumentsToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-broker-documents' + URIQuery(parameters)).then(response => response.data)

export const getNeedsSignedForeignShipperToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-signed-foreign-shipper' + URIQuery(parameters)).then(response => response.data)

export const getWaitingOnTripToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/waiting-on-trip' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsCheckInToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-check-in' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsManufacturerLabelToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-manufacturer-label' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsTirePressureLabelToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-tire-pressure-label' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsPhotosToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-photos' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsOEMSiteCheckedForRecallsToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-oem-site-checked-for-recalls' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsCaRoUploadedToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-ca-ro-uploaded' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsRecallWorkToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-recall-work' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsClusterRemovedToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-cluster-removed' + URIQuery({ ...parameters })).then(response => response.data)

export const getWaitingOnThirdPartyClusterConversionCompanyToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/waiting-on-third-party-cluster-conversion' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getNeedsClusterConversionInHouseToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-cluster-conversion-in-house' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsClusterConversionShipperToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-cluster-conversion-shipper' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsClusterDeliveredToThirdPartyConversionCompanyToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<ClusterShipperDto[]>>('/api/to-do-lists/needs-cluster-delivered-to-third-party-conversion-company' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getNeedsInHouseAdditionalProgrammingToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-in-house-additional-programming' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getNeedsThirdPartyAdditionalProgrammingToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-third-party-additional-programming' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getWaitingOnThirdPartyAdditionalProgrammingToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/waiting-on-third-party-additional-programming' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getNeedsClusterReinstalledToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-cluster-reinstalled' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsIncorrectMileageResolutionToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-incorrect-mileage-resolution' + URIQuery({ ...parameters })).then(response => response.data)

export const getPulledClusterPhotoInformation = (vehicleId: string) =>
  apiClient.get<ApiResponse<PulledClusterPhotoDto>>(`api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/pulled-cluster`).then(response => response.data)

export const getPulledClusterPhotoFile = (vehicleId: string, fileName: string) =>
  apiClient.get(`api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/pulled-cluster${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const updatePulledClusterPhotoInformation = (vehicleId: string, values: PulledClusterPhotoDto) => {
  const payload = new FormData()

  payload.append('pulledClusterPhotoFile', values.pulledClusterPhotoFile!)
  return apiClient<ApiResponse<PulledClusterPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/pulled-cluster`
  })
    .then(response => response.data)
    .catch(e => {
      throw e
    })
}

export const getNeedsClusterReinstalledClusterWithOdometerPhotoInformation = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterReinstalledClusterWithOdometerPhotoDto>>(
      `api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-cluster-with-odometer`
    )
    .then(response => response.data)

export const getNeedsClusterReinstalledClusterWithOdometerPhotoFile = (vehicleId: string, fileName: string) =>
  apiClient.get(`api/vehicles${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-cluster-with-odometer${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const updateNeedsClusterReinstalledClusterWithOdometerPhotoInformation = (
  vehicleId: string,
  values: NeedsClusterReinstalledClusterWithOdometerPhotoDto
) => {
  const payload = new FormData()
  payload.append('clusterWithOdometerPhotoFile', values.clusterReinstallClusterWithOdometerPhotoFile!)
  return apiClient<ApiResponse<NeedsClusterReinstalledClusterWithOdometerPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-cluster-with-odometer`
  })
    .then(response => response.data)
    .catch(e => {
      throw e
    })
}

export const getNeedsClusterReinstalledImporterDoorLabelPhotoInformation = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterReinstalledImporterDoorLabelPhotoDto>>(
      `api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-importer-door-label`
    )
    .then(response => response.data)

export const getNeedsClusterReinstalledImporterDoorLabelPhotoFile = (vehicleId: string, fileName: string) =>
  apiClient.get(`api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-importer-door-label${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const updateNeedsClusterReinstalledImporterDoorLabelPhotoInformation = (vehicleId: string, values: NeedsClusterReinstalledImporterDoorLabelPhotoDto) => {
  const payload = new FormData()
  payload.append('importerDoorLabelPhotoFile', values.clusterReinstallImporterDoorLabelPhotoFile!)
  return apiClient<ApiResponse<NeedsClusterReinstalledImporterDoorLabelPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-importer-door-label`
  })
    .then(response => response.data)
    .catch(e => {
      throw e
    })
}

export const getNeedsClusterReinstalledComboPhotoInformation = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterReinstalledComboPhotoDto>>(`api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-combo`)
    .then(response => response.data)

export const getNeedsClusterReinstalledComboPhotoFile = (vehicleId: string, fileName: string) =>
  apiClient.get(`api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-combo`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const updateNeedsClusterReinstalledComboPhotoInformation = (vehicleId: string, values: NeedsClusterReinstalledComboPhotoDto) => {
  const payload = new FormData()
  payload.append('comboPhotoFile', values.clusterReinstallComboPhotoFile!)
  return apiClient<ApiResponse<NeedsClusterReinstalledComboPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-cluster-reinstalled-combo`
  })
    .then(response => response.data)
    .catch(e => {
      throw e
    })
}

export const getThirdPartyClusterDeliveryPhotoInformation = (clusterShipperId: string) =>
  apiClient
    .get<ApiResponse<ThirdPartyClusterDeliveryPhotoDto>>(`api/vehicles/${encodeURIComponent(clusterShipperId)}/to-do-list/third-party-cluster-delivery`)
    .then(response => response.data)

export const getThirdPartyClusterDeliveryPhotoFile = (clusterShipperId: string, fileName: string) =>
  apiClient.get(`api/vehicles/${encodeURIComponent(clusterShipperId)}/to-do-list/third-party-cluster-delivery${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const updateThirdPartyClusterDeliveryPhotoInformation = (clusterShipperId: string, values: ThirdPartyClusterDeliveryPhotoDto) => {
  const payload = new FormData()
  payload.append('thirdPartyClusterDeliveryPhotoFile', values.thirdPartyClusterDeliveryPhotoFile!)
  return apiClient<ApiResponse<ThirdPartyClusterDeliveryPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `api/vehicles/${encodeURIComponent(clusterShipperId)}/to-do-list/third-party-cluster-delivery`
  })
    .then(response => response.data)
    .catch(e => {
      throw e
    })
}

export const getNeeds7501DocumentMichiganToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-7501-document-michigan' + URIQuery(parameters)).then(response => response.data)

// export const sendNeeds7501DocumentMichiganEmailExporter = (
//   vehicleId: string,
//   values: Needs7501DocumentMichiganEmailExporterDto
// ) =>
//   apiClient
//     .post(`api/vehicles/${encodeURIComponent(vehicleId)}/to-do-list/needs-7501-document-michigan`, values)
//     .then(response => response.data)

export const sendNeeds7501DocumentMichiganEmailExporter = (values: Needs7501DocumentMichiganEmailExporterDto) =>
  apiClient.post(`api/to-do-list/needs-7501-document-michigan`, values).then(response => response.data)

export const getNeedsCANOwnershipMichiganToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-can-ownership-michigan' + URIQuery(parameters)).then(response => response.data)

export const sendNeedsCANOwnershipMichiganEmailExporter = (values: NeedsCANOwnershipMichiganEmailExporterDto) =>
  apiClient.post(`api/to-do-list/needs-can-ownership-michigan`, values).then(response => response.data)

// export const getNeedsInfoForApplicationPacketMichiganToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-info-for-application-packet-michigan' + URIQuery({ ...parameters }))
//     .then(response => response.data)

// export const getNeedsToBePrintedAndSignedToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-to-be-printed-and-signed' + URIQuery({ ...parameters }))
//     .then(response => response.data)

// export const getNeedsToBeTakenToSecretaryOfStateToDoList = (parameters: ToDoListNeedsToBeTakenToSecretaryOfStateParameters) =>
//   apiClient
//     .get<ApiResponse<MichiganSoSBundleDto[]>>('/api/to-do-lists/needs-to-be-taken-to-secretary-of-state' + URIQuery({ ...parameters }))
//     .then(response => response.data)

// export const getNeedsMichiganTitleApplicationReceiptToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-michigan-title-application-receipt' + URIQuery({ ...parameters }))
//     .then(response => response.data)

export const getNeedsMichiganTitleFromSecretaryOfStateToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-michigan-title-from-secretary-of-state' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getMichiganTitlesNeedsToBeSentOutgoingToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/michigan-titles-needs-to-be-sent-outgoing' + URIQuery({ ...parameters }))
    .then(response => response.data)

// export const getNeedsInCANOwnershipOhioToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-can-ownership-ohio' + URIQuery({ ...parameters }))
//     .then(response => response.data)

// export const getNeeds7501DocumentOhioToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-7501-document-ohio' + URIQuery({ ...parameters }))
//     .then(response => response.data)

// export const getNeedsInfoForApplicationPacketOhioToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-info-for-application-packet-ohio' + URIQuery({ ...parameters }))
//     .then(response => response.data)

// export const getNeedsToBeMarkedReadyForBuildABoxToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-to-be-marked-ready-for-build-a-box' + URIQuery({ ...parameters }))
//     .then(response => response.data)

export const getNeedsToBeAddedToABundleToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-to-be-added-to-a-bundle' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsToHaveBoxFinishedToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-to-have-box-finished' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsToBeTakenToFedExToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-to-be-taken-to-fed-ex' + URIQuery({ ...parameters })).then(response => response.data)

export const getWaitingOnOhioTitleProcessingToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/waiting-on-ohio-title-processing' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsNewTitlesOCRdToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-new-titles-ocrd' + URIQuery({ ...parameters })).then(response => response.data)

// export const getNeedsCANOwnershipMichiganToDoList = (parameters: ToDoListNeedsCANOwnershipMichiganParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-can-ownership-michigan' + URIQuery({ ...parameters }))
//     .then(response => response.data)

// export const getNeeds7501DocumentMichiganToDoList = (parameters: ToDoListNeeds7501DocumentMichiganParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-7501-document-michigan' + URIQuery({ ...parameters }))
//     .then(response => response.data)

export const getNeedsInfoForApplicationPacketMichiganToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-info-for-application-packet-michigan' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getNeedsToBePrintedAndSignedToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-to-be-printed-and-signed' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsToBeTakenToSecretaryOfStateToDoList = (parameters: ToDoListNeedsToBeTakenToSecretaryOfStateParameters) =>
  apiClient
    .get<ApiResponse<MichiganSOSBundleDto[]>>('/api/to-do-lists/needs-to-be-taken-to-secretary-of-state' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getNeedsMichiganTitleApplicationReceiptToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-michigan-title-application-receipt' + URIQuery({ ...parameters }))
    .then(response => response.data)

// export const getNeedsMichiganTitleFromSecretaryOfStateToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-michigan-title-from-secretary-of-state' + URIQuery({ ...parameters }))
//     .then(response => response.data)

// export const getMichiganTitlesNeedsToBeSentOutgoingToDoList = (parameters: VehicleToDoListParameters) =>
//   apiClient
//     .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/michigan-titles-needs-to-be-sent-outgoing' + URIQuery({ ...parameters }))
//     .then(response => response.data)

export const getOhioTitlesNeedsToBeSentOutgoingToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/ohio-titles-needs-to-be-sent-outgoing' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getVehiclesEligibleForConformityToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/vehicles-eligible-for-conformity' + URIQuery({ ...parameters })).then(response => response.data)

export const getApproaching120DaysSinceEntryDateToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/approaching-120-days-since-entry-date' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getSendBackToCanadaToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/send-back-to-canada' + URIQuery({ ...parameters })).then(response => response.data)

export const getReadyForOutboundTripToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/ready-for-outbound-trip' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsToBeMovedToStagingToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-to-be-moved-to-staging' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsDriversLicensePhotoUploadedToDoList = (parameters: OutboundTripsParameters) =>
  apiClient
    .get<ApiResponse<OutboundTripDto[]>>('/api/to-do-lists/needs-drivers-license-photo-uploaded' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getNeedsSignedBOLToDoList = (parameters: OutboundTripsParameters) =>
  apiClient.get<ApiResponse<OutboundTripDto[]>>('/api/to-do-lists/needs-signed-bol' + URIQuery({ ...parameters })).then(response => response.data)

export const getNeedsDamageRepairedToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/needs-damage-repaired' + URIQuery({ ...parameters })).then(response => response.data)

export const getCreated5DaysAgoOrMoreAndHasNotBeenSentToDOTToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/created-5-days-ago-or-more-and-has-not-been-sent-to-dot' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getArchivedToDoList = (parameters: VehicleToDoListParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/to-do-lists/archived' + URIQuery({ ...parameters })).then(response => response.data)
